import { render, staticRenderFns } from "./PrivateTemplate.vue?vue&type=template&id=4f5ea0ca&scoped=true&"
import script from "./PrivateTemplate.vue?vue&type=script&lang=js&"
export * from "./PrivateTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5ea0ca",
  null
  
)

export default component.exports